const businessCategories = [
    "Acuicultura",
    "Actividad al Aire Libre",
    "Adaptación de Contenido Multilingües",
    "Administración de Condominios",
    "Administración de Propiedad",
    "Administración Pública",
    "Aduana e Inmigración",
    "Agencia de Publicidad",
    "Agencia de Reclutamiento",
    "Agencia de Viaje",
    "Agencia Hípica",
    "Agricultura de Precisión",
    "Agricultura Hidropónica",
    "Agricultura Orgánica",
    "Agricultura Sostenible",
    "Agroforestería",
    "Airbnb",
    "Alarma y Sistema Antirrobo",
    "Albañilería y Piedra",
    "Alimentación para Mascota",
    "Alquiler de Auto",
    "Alquiler de Bicicleta",
    "Alquiler de Caravana",
    "Alquiler de Decoración Temática",
    "Alquiler de Dron",
    "Alquiler de Equipo de Realidad Virtual",
    "Alquiler de Equipo de Sonido",
    "Alquiler de Equipo Médico",
    "Alquiler de Espacio Publicitario en Edificio",
    "Alquiler de Herramienta Industrial",
    "Alquiler de Instalación Deportiva",
    "Alquiler de Instrumento Científico",
    "Alquiler de Maquinaria Pesada",
    "Alquiler de Maquinaria para Construcción",
    "Alquiler de Moto de Agua",
    "Alquiler de Scooter Eléctrico",
    "Alquiler de Vacación",
    "Alquiler de Vehículo Recreativo (RV)",
    "Alquiler de Vestuario Teatral",
    "Almacenamiento de Producto Farmacéutico",
    "Análisis de Feedback del Cliente",
    "Análisis de Huella Dactilar",
    "Análisis de Penetración",
    "Análisis de Proceso de Producción",
    "Análisis Geoespacial",
    "Análisis Predictivo",
    "Análisis Sensorial de Alimento",
    "Animación 3D",
    "Animación de Fiesta Infantil",
    "Apicultura",
    "Aplicación Interactiva",
    "Arquitectura y Diseño",
    "Arreglo Floral Funerario",
    "Arrendamiento Comercial",
    "Arrendamiento de Local Comercial",
    "Arrendamiento de Oficina",
    "Aromaterapia",
    "Arte Marcial",
    "Asesoría de Crédito",
    "Asesoría de Inversión",
    "Asesoría de Marketing Digital",
    "Asesoría de Recurso Humano",
    "Asesoría en Entrenamiento Deportivo",
    "Asesoría en Franquicia",
    "Asesoría en Inversión para Jubilado",
    "Asesoría en Proceso de Certificación",
    "Asesoría en Seguridad Informática",
    "Asesoría en Suplementación Nutricional",
    "Asesoría en Testamento",
    "Asesoría Financiera",
    "Asesoría Nutricional",
    "Asesoramiento en Sistema de Control por Voz",
    "Asistencia en Carretera",
    "Asistencia Psicológica para Duelo",
    "Auditoría de Calidad",
    "Auditoría de Huella de Carbono",
    "Auditoría de Procedimiento Médico",
    "Auditoría de Seguridad de Aplicación Móvil",
    "Auditoría de Seguridad de Edificación",
    "Auditoría Energética",
    "Automatización Industrial",
    "Ayurveda",
    "Banco de Alimento",
    "Bar",
    "Barra",
    "Barra, Comida & Spa",
    "Barra y Comida",
    "Bed and Breakfast",
    "Bienes Raices",
    "Blanqueamiento Dental",
    "Brunch",
    "Bolera",
    "Branding e Identidad Corporativa",
    "Bronceado",
    "Cafetería",
    "Cálculo de Beneficio de Jubilación",
    "Campo y Club de Golf",
    "Capacitación Corporativa",
    "Capacitación en Accesibilidad Digital",
    "Capacitación en Comunicación Efectiva",
    "Capacitación en Electricidad Industrial",
    "Capacitación en Energía Solar Fotovoltaica",
    "Capacitación en Finanza Personal",
    "Capacitación en Habilidad de Supervivencia",
    "Capacitación en Mantenimiento de Maquinaria",
    "Capacitación en Primero Auxilio",
    "Capacitación en Primero Auxilio para Hogar",
    "Capacitación en Realidad Virtual",
    "Capacitación en Seguridad para Profesional de la Salud",
    "Capacitación en Sensibilidad Cultural",
    "Capacitación en Servicio al Cliente",
    "Capacitación en Soldadura",
    "Capacitación en Tecnología",
    "Capacitación para Ejecutivo",
    "Capacitación Vocacional",
    "Cartografía y Mapa Digital",
    "Casino y Establecimiento de Juego",
    "Carteras y Zapatos",
    "Centro Comunitario",
    "Centro de Apoyo Educativo",
    "Centro de Educación Profesional",
    "Centro de Escalada",
    "Centro de Patinaje",
    "Centro de Tratamiento Antiedad",
    "Ceremonia de Voto Renovado",
    "Ceremonia Espiritual",
    "Certificación de Edificio Energéticamente Eficiente",
    "Certificación de Producto",
    "Certificación ISO",
    "Certificación Ecológica",
    "Certificación LEED",
    "Cine y Teatro",
    "Cirugía Ocular en Animal",
    "Cirugía Ortopédica en Animal",
    "Cirugía Estética",
    "Clase de Cata de Vino",
    "Clase de Chi Kung (Qigong)",
    "Clase de Cocina Básica",
    "Clase de Cocina Experimental",
    "Clase de Danza y Baile",
    "Clase de Habilidad Social",
    "Clase de Música",
    "Clase de Pintura y Dibujo",
    "Clase de Preparación al Parto",
    "Clínica de Belleza Integral",
    "Coaching Ejecutivo",
    "Coaching Empresarial",
    "Cocina Industrial",
    "Coffee Truck",
    "Coloración de Cabello",
    "Comida Rápida",
    "Compartición de Vehículo (Carpooling)",
    "Compensación de Carbono",
    "Comunicación de Crisis",
    "Concierge Personal para Ejecutivo",
    "Concierto y Festival",
    "Consultoría Astrológica",
    "Consultoría de Calidad Hospitalaria",
    "Consultoría de Desarrollo Profesional",
    "Consultoría de Diseño Accesible",
    "Consultoría de Energía Limpia",
    "Consultoría de Imagen",
    "Consultoría de Inclusión y Accesibilidad",
    "Consultoría de Lactancia",
    "Consultoría en Plan de Pensión",
    "Consultoría Educativa",
    "Consultoría Empresarial",
    "Consultoría en Adaptación al Cambio Climático",
    "Consultoría en Arquitectura de Microservicio",
    "Consultoría en Big Data",
    "Consultoría en Casa Inteligente",
    "Consultoría en Clima Laboral",
    "Consultoría en Cocina Molecular",
    "Consultoría en Comercio Internacional",
    "Consultoría en Construcción Naval",
    "Consultoría en Cumplimiento Normativo",
    "Consultoría en Diseño Algorítmico",
    "Consultoría en Diseño Centrado en el Usuario",
    "Consultoría en Diseño de Moda",
    "Consultoría en Diversidad e Inclusión",
    "Consultoría en Energía Renovable",
    "Consultoría en Estilo de Vida",
    "Consultoría en Etiquetado Energético",
    "Consultoría en Experiencia del Cliente (CX)",
    "Consultoría en Gestión de Recurso Natural",
    "Consultoría en Ingeniería Aeroespacial",
    "Consultoría en Innovación",
    "Consultoría en Innovación Tecnológica",
    "Consultoría en Lean Manufacturing",
    "Consultoría en Localización de Software",
    "Consultoría en Microgrid",
    "Consultoría en Nutrición Deportiva",
    "Consultoría en Planificación de Cementerio",
    "Consultoría en Planificación de Emergencia",
    "Consultoría en Plataforma Multi-Nube",
    "Consultoría en Preparación de Legado",
    "Consultoría en Prevención de Desastre",
    "Consultoría en Protocolo de Seguridad",
    "Consultoría en Publicación Científica",
    "Consultoría en Rehabilitación Física",
    "Consultoría en RV para Negocio",
    "Consultoría en Sistema de Gestión de Calidad",
    "Consultoría en Tecnología de Alimento",
    "Consultoría en Teledetección",
    "Consultoría en Vehículo Autónomo",
    "Consultoría Energética",
    "Consultoría Legal",
    "Consultoría para Reducción del Consumo Energético",
    "Consultoría para Reserva Natural",
    "Consultoría para Restaurante",
    "Consultoría para Startup",
    "Contabilidad y Teneduría de Libro",
    "Contenerización con Docker y Kubernetes",
    "Control de Plaga",
    "Control de Plaga Agrícola sin Pesticida",
    "Control de Plaga Ecológico",
    "Contratista General",
    "Corretaje de Aduana",
    "Corretaje de Bien Raíz",
    "Corretaje de Hipoteca",
    "Corte de Cabello y Barbería",
    "Creación de Journey Map",
    "Creación de Prototipo Interactivo",
    "Cremación",
    "Crianza de Animal de Granja",
    "Crioterapia",
    "Cuidado de la Salud a Domicilio",
    "Cuidado de Mascota",
    "Cuidado Nocturno para Bebé",
    "Cuidado para Anciano",
    "Cuidado Postnatal",
    "Cuidado Veterinario para Animal Exótico",
    "Cuidado y Mantenimiento de Terrario",
    "Cultivo de Fruta y Verdura",
    "Cultivo de Grano y Cereal",
    "Curso de Cocina Básica",
    "Curso de Navegación",
    "Correo Privado",
    "Accesorios y Artículos de defensa miselaneo",
    "Bien Raíz Internacional",
    "Remoción y Reubicación de Colmenas de Abejas",
    "Servicios Textiles",
    "Entretenimiento Media",
    "Tienda de Arte",
    "Tienda de Diecast",
    "Servicios de Sonografía",
    "Smokeshop",
    "Decoración de Uña",
    "Decoración Floral para Evento",
    "Comida para Eventos",
    "Postres para Eventos",
    "Decoración para Eventos",
    "Demostración y Taller de Gastronomía Molecular",
    "Depilación",
    "Deporte de Aventura",
    "Desarrollo Blockchain",
    "Desarrollo de Algoritmo de Machine Learning",
    "Desarrollo de Aplicación Móvil",
    "Desarrollo de Contenido Digital",
    "Desarrollo de Contenido Digital Accesible",
    "Desarrollo de Experiencia de Realidad Aumentada",
    "Desarrollo de Menú Molecular",
    "Desarrollo de Nuevo Producto",
    "Desarrollo de Nuevo Producto Alimenticio",
    "Desarrollo de Patente",
    "Desarrollo de Proyecto Artístico",
    "Desarrollo de Sistema de Navegación",
    "Desarrollo de Software",
    "Desarrollo de Solución de Movilidad Compartida",
    "Desarrollo de Tecnología Sustentable",
    "Desarrollo de Videojuego",
    "Desarrollo Inmobiliario",
    "Desarrollo Web",
    "Diagnóstico de Trastorno del Aprendizaje",
    "Diagnóstico Neuropsicológico",
    "Digitalización de Registro Funerario",
    "Dirección Artística",
    "Dirección de Cine y TV",
    "Dirección de Fotografía",
    "Discoteca y Bar",
    "Diseño Computacional de Fachada",
    "Diseño de Embarcación",
    "Diseño de Escenario",
    "Diseño de Experiencia de Producto",
    "Diseño de Infraestructura Resiliente",
    "Diseño de Interior",
    "Diseño de Programa de Fidelización",
    "Diseño de Sonrisa",
    "Diseño de Uniforme Corporativo",
    "Diseño de Vestuario para Cine y TV",
    "Diseño de Vivienda Accesible",
    "Diseño de Yate de Lujo",
    "Diseño Gráfico",
    "Diseño UX/UI",
    "Dispensario",
    "Diseño y Prototipado de Producto",
    "Distribución de Material Quirúrgico",
    "Distribución de Producto Agrícola",
    "Distribuidor de Alimento y Bebida",
    "Frappe y Bebidas",
    "Bebidas y Acai",
    "Bebidas Nutritivas",
    "Dron para Agricultura",
    "Dry Cleaning",
    "Edición y Montaje de Video",
    "Edición y Postproducción de Audio y Video",
    "Edificio de Energía Cero",
    "Educación de Adulto",
    "Educación en Línea",
    "Educación Especial",
    "Educación Infantil",
    "Educación para Niño con Necesidad Especial",
    "Educación Prenatal",
    "Email Marketing",
    "Empaque Sostenible para Alimento",
    "Energía Eólica",
    "Energía Geotérmica",
    "Energía Hidráulica",
    "Energía Renovable",
    "Ensayo de Material Aeroespacial",
    "Entrega de Comida",
    "Entrega de Supermercado",
    "Entrega de Última Milla",
    "Entrenamiento de Animal Salvaje",
    "Entrenamiento de Modelo de Traducción Automática",
    "Entrenamiento de Perro Guía",
    "Entrenamiento en Automatización y Control",
    "Entrenamiento en Manejo del Estrés",
    "Entrenamiento para Movilidad Asistida",
    "Entrenamiento Personal y Fitness",
    "Equipo de Respuesta a Desastre",
    "Escuela Bilingüe",
    "Escuela de Arte y Oficio",
    "Escuela de Cocina",
    "Escuela de Fútbol",
    "Escuela de Idioma",
    "Escuela de Manejo",
    "Escuela de Música y Danza",
    "Escuela de Natación",
    "Escuela de Negocio",
    "Escuela de Teatro",
    "Escuela Montessori",
    "Escuela Privada",
    "Escuela Técnica",
    "Estética Canina y Felina",
    "Estética Integral",
    "Estetica Rejuvenecedora",
    "Estilismo Nupcial",
    "Estilismo para Boda",
    "Estilismo de Mesa (Tablescaping)",
    "Estudio de Vida Útil de Producto",
    "Evaluación de Antigüedad",
    "Evaluación de Bien de Colección",
    "Evaluación de Conformidad",
    "Evaluación de Desempeño",
    "Evaluación de Diversidad Corporativa",
    "Evaluación de Eficiencia Energética en Empresa",
    "Evaluación de Impacto Ambiental",
    "Evaluación de Planta de Biogás",
    "Evaluación de Responsabilidad Social Corporativa",
    "Evaluación de Riesgo Clínico",
    "Evaluación de Riesgo Natural",
    "Evaluación de Seguridad de Embarcación",
    "Evaluación de Vulnerabilidad Climática",
    "Evaluación del Ciclo de Vida de Edificio",
    "Evaluación y Ayuda Post-Desastre",
    "Evaluación para Certificación LEED",
    "Evaluación Psicoeducativa",
    "Evaluación Psicológica Laboral",
    "Evaluación Psicométrica",
    "Exploración de Petróleo y Gas",
    "Exposición de Arte",
    "Fabricación de Acero",
    "Fabricación de Herramienta",
    "Fabricación de Metal",
    "Farmacia y Droguería",
    "Farmacia",
    "Firewall de Nueva Generación",
    "Fisioterapia",
    "Fitoterapia",
    "Fitness Funcional",
    "Floristería",
    "Flor de Bach",
    "Food Truck",
    "Fotografía y Videografía",
    "Galería de Arte y Museo",
    "Ganadería",
    "Gestión Cultural",
    "Gestión de Base de Dato",
    "Gestión de Beneficio Laboral",
    "Gestión de Construcción",
    "Gestión de Derecho Musical para Producción",
    "Gestión de Emergencia",
    "Gestión de Espacio Cultural",
    "Gestión de Evento",
    "Gestión de Experiencia en Punto de Venta",
    "Gestión de Flota",
    "Gestión de Incidente en Salud",
    "Gestión de Infraestructura en la Nube",
    "Gestión de Inventario",
    "Gestión de la Cadena de Suministro",
    "Gestión de Liga Deportiva Local",
    "Gestión de Nómina",
    "Gestión de Patrimonio",
    "Gestión de Plan de Carrera",
    "Gestión de Propiedad",
    "Gestión de Proyecto",
    "Gestión de Recurso Hídrico en Zona Afectada",
    "Gestión de Refugio de Emergencia",
    "Gestión de Residuo",
    "Gestión de Residuo Peligroso",
    "Gestión de Reserva y Entrada",
    "Gestión de Servidor Virtual",
    "Gestión de Terreno Funerario",
    "Gestión de Viaje Corporativo",
    "Gimnasio y Centro de Fitness",
    "Gomera",
    "Guardia de Seguridad",
    "Guardería de Mascota",
    "Guía Turística",
    "Headhunting",
    "Hidroterapia",
    "Hipnoterapia",
    "Home Staging",
    "Homeopatía",
    "Hospedaje para Mascota",
    "Hostel",
    "Hospital y Clínica",
    "Hotel y Resort",
    "Implementación de Política Corporativa",
    "Implementación de Red de Carga",
    "Implementación de Seis Sigma",
    "Impresión de Diseños",
    "Impresión 3D",
    "Ingeniería Ambiental",
    "Ingeniería Civil",
    "Ingeniería de Precisión",
    "Ingeniería Eléctrica",
    "Ingeniería Estructural",
    "Ingeniería Mecánica",
    "Innovación en Energía Renovable",
    "Inspección de Vivienda",
    "Instalación de Dispositivo IoT",
    "Instalación de Equipo de RV",
    "Instalación de Panel Solar",
    "Instalación de Piso",
    "Instalación de Sistema de Automatización del Hogar",
    "Instalación de Sistema de Energía Geotérmica",
    "Instalación de Sistema de Sonido",
    "Instalación de Techo Verde",
    "Instalación de Turbina Eólica",
    "Instalación y Mantenimiento de Red",
    "Institución de Educación en Línea",
    "Interpretación en Conferencia",
    "Interpretación en Lengua de Seña",
    "Interpretación Médica",
    "Interpretación Simultánea",
    "Investigación Antifraude",
    "Investigación Biomédica",
    "Investigación de Mercado",
    "Investigación de Usuario",
    "Investigación Digital Forense",
    "Investigación en Biotecnología",
    "Investigación en Inteligencia Artificial",
    "Investigación en Propulsión Aeroespacial",
    "Investigación en Sistema de Transporte Sostenible",
    "Investigación en Técnica Culinaria Innovadora",
    "Investigación Forense",
    "Investigación Geológica",
    "Investigación Industrial",
    "Inversión Inmobiliaria",
    "Joyería y Relojería",
    "Joyería",
    "Boutique",
    "Tienda de Musica",
    "Tienda de Botánica",
    "Tienda especializada en Telas",
    "Tienda de accesorios de Pesca y Buseo",
    "Laboratorio de Prueba",
    "Laundromat",
    "Lavado de Auto",
    "Lectura de Tarot",
    "Librería",
    "Limpieza Industrial",
    "Línea de Crucero",
    "Localización de Software y Sitio Web",
    "Logística de Cadena de Frío",
    "Logística para Distribución de Ayuda Humanitaria",
    "Logística y Envío",
    "Manejo de Irrigación Eficiente",
    "Manejo Integrado de Plaga",
    "Manejo Integrado de Plaga Urbana",
    "Manejo Sostenible de Suelo",
    "Manicure y Pedicure",
    "Mantenimiento de Cementerio",
    "Mantenimiento de Panel Solar",
    "Mantenimiento de Planta de Energía",
    "Mantenimiento de Robot Aspirador",
    "Manufactura por Contrato",
    "Manufactura Textil",
    "Maquillaje Profesional",
    "Maquinado CNC",
    "Maquinaria Agrícola",
    "Marketing con Influencer",
    "Marketing de Afiliado",
    "Marketing de Contenido",
    "Marketing de Evento",
    "Marketing en Red Social",
    "Masaje Estético",
    "Masterización de Audio",
    "Material de Construcción Ecológico",
    "Mausoleo y Nicho",
    "Mejora Continua en Operación",
    "Micropigmentación y Microblading",
    "Migración a la Nube",
    "Modelado 3D del Terreno",
    "Modelado Aerodinámico",
    "Modelado Hidrodinámico",
    "Modelado Paramétrico de Edificación",
    "Moldeo de Plástico",
    "Moldeo por Inyección",
    "Monitoreo Climático para Agricultura",
    "Monitoreo de Actividad Sospechosa",
    "Monitoreo de Calidad del Aire",
    "Monitoreo de Ecosistema",
    "Monitoreo de Fauna Silvestre",
    "Monitoreo Remoto",
    "Monitoreo Satelital de Cultivo",
    "Monitoreo SOC",
    "Motivación Laboral",
    "Mudanza",
    "Mudanza Internacional",
    "Museografía y Diseño de Exposición",
    "Naturopatía",
    "Nutrición para Condición Crónica",
    "Nutrición para el Embarazo",
    "Operador Turístico",
    "Optimización de Diseño con IA",
    "Optimización del Customer Journey",
    "Optimización SEO Multilingüe",
    "Organización de Despedida de Soltero/a",
    "Organización de Feria Cultural",
    "Organización de Festival Gastronómico",
    "Organización de Itinerario de Viaje",
    "Organización de Torneo de Golf",
    "Organización Benéfica",
    "Organización de Voluntariado",
    "Organización Religiosa",
    "Outsourcing de Personal",
    "Paisajismo y Arquitectura de Jardín",
    "Parque de Atracción",
    "Paseo de Perro",
    "Pastelería y Panadería",
    "Patente y Marca Registrada",
    "Peinado y Estilismo",
    "Permacultura",
    "Plan de Adaptación Comunitaria",
    "Plan de Ahorro para la Tercera Edad",
    "Plan de Previsión Funeraria",
    "Planificación de Boda",
    "Planificación de Boda Destino",
    "Planificación de Cumpleaño Temático",
    "Planificación de Espacio Comercial",
    "Planificación de Estrategia de Comunicación Interna",
    "Planificación de Evento",
    "Planificación de Infraestructura para Vehículo Eléctrico",
    "Planificación de Maratón y Carrera",
    "Planificación de Resiliencia para Empresa",
    "Planificación Financiera",
    "Planificación Financiera Post-Retiro",
    "Planificación Urbana",
    "Planificación Urbana y Regional",
    "Plataforma de Comercio Electrónico",
    "Plataforma de Streaming",
    "Polygraph Testing",
    "Postproducción de Video",
    "Preparación de Examen",
    "Preparación de Impuesto",
    "Prevención de Infección en Entorno Hospitalario",
    "Producción de Alimento y Bebida",
    "Producción de Biofertilizante",
    "Producción de Boletín Corporativo",
    "Producción de Cultivo Hidropónico",
    "Producción de Documental",
    "Producción de Espectáculo",
    "Producción de Lácteo",
    "Producción de Podcast",
    "Producción de Publicidad Audiovisual",
    "Producción de Video",
    "Producción de Video Musical",
    "Producción en Vivo de Evento",
    "Producción Musical",
    "Tienda de Música",
    "Producción Teatral",
    "Producción de White Paper",
    "Producto de Belleza",
    "Programación de Robot de Servicio",
    "Programa de Apoyo Laboral para Discapacitado",
    "Programa de Aprendizaje Acelerado",
    "Programa de Desarrollo Juvenil",
    "Programa de Inclusión",
    "Protección de Infraestructura Crítica",
    "Protección de Propiedad Industrial",
    "Prototipado con Impresión 3D",
    "Prototipado de Vehículo Aéreo No Tripulado (UAV)",
    "Proyecto de Historia Oral",
    "Proyecto de Restauración de Ecosistema",
    "Prueba de Usabilidad",
    "Psicometría Clínica",
    "Publicidad en Autobús",
    "Publicidad en Parada de Autobús",
    "Publicidad en Valla Publicitaria",
    "Publicidad PPC",
    "Realidad Virtual y Aumentada",
    "Reconstrucción de Accidente",
    "Recubrimiento Industrial",
    "Reducción de Costo Operativo",
    "Reducción de Medida",
    "Refacción Automotriz",
    "Refugio para Persona Sin Hogar",
    "Registro de Derecho de Autor",
    "Regrowing",
    "Rehabilitación de Espacio Cultural",
    "Rehabilitación Postoperatoria",
    "Rejuvenecimiento Cutáneo",
    "Rejuvenecimiento Facial y Corporal",
    "Relación con Inversor",
    "Relación Pública",
    "Relojería",
    "Remodelación de Propiedad",
    "Renta de Auto de Lujo",
    "Reparación de Automóvil",
    "Reparación de Computadora",
    "Reparación de Cristal Automotriz",
    "Reparación de Maquinaria Pesada",
    "Reparación y Mantenimiento de Buque",
    "Rescate y Adopción de Animal",
    "Rescate y Refugio para Animal",
    "Respuesta a Incidente de Seguridad",
    "Restauración Arquitectónica",
    "Restauración de Monumento Histórico",
    "Restauración de Obra de Arte",
    "Restaurante",
    "Revisión de Contenido Técnico",
    "Revisión y Corrección de Traducción Automatizada",
    "Rotulación de Vehículo",
    "Ropa y Accesorios Deportivos",
    "Ropa y Accesorios de bebé",
    "Salón de Evento",
    "Salud Capilar Avanzada",
    "Salud Mental y Psicología",
    "SEO y Marketing Digital",
    "Seguridad Empresarial",
    "Seguridad Industrial",
    "Seguridad Marítima",
    "Seguridad para Evento",
    "Seguridad Pública",
    "Seguridad Residencial",
    "Seguridad Zero Trust",
    "Sensor Agrícola",
    "Servicio Bancario",
    "Bakery",
    "Servicio de Aerolínea",
    "Servicio de Almacenamiento",
    "Servicio de Análisis de Huella Dactilar",
    "Servicio de Análisis Químico",
    "Servicio de Andamio",
    "Servicio de Asistente Virtual",
    "Servicio de Auditoría Interna",
    "Servicio de Ayuda para Recado",
    "Servicio de Biodiversidad",
    "Servicio de Ciberseguridad",
    "Servicio de Confección a Medida",
    "Servicio de Conserjería",
    "Servicio de Contabilidad",
    "Servicio de Control de Acceso",
    "Servicio de Cronometraje en Competencia",
    "Servicio de Degustación de Alimento",
    "Servicio de Diseño Textil",
    "Servicio de DJ para Boda",
    "Servicio de Doblaje",
    "Servicio de Electricidad",
    "Servicio de Empaque",
    "Servicio de Energía de Respaldo",
    "Servicio de Escolta Personal",
    "Servicio de ETL (Extracción, Transformación y Carga)",
    "Servicio de Excavación",
    "Servicio de Exhibición de Animal Exótico",
    "Servicio de Fabricación Digital para Arquitectura",
    "Servicio de Fontanería",
    "Servicio de Plomería",
    "Servicio de Fotogrametría 3D",
    "Servicio de Geofísica",
    "Servicio de Gestión de Residuo",
    "Servicio de Guardería",
    "Servicio de HVAC (Climatización)",
    "Servicio de IA y Machine Learning",
    "Servicio de Identificación Biométrica",
    "Servicio de Jardinería",
    "Servicio de Limusina",
    "Servicio de Masaje",
    "Servicio de Memorialización",
    "Servicio de Mensajería y Entrega",
    "Servicio de Minería",
    "Servicio de Niñera",
    "Servicio de Notaría",
    "Servicio de Nutrición Pediátrica",
    "Servicio de Pintura",
    "Servicio de Planificación Espacial",
    "Servicio de Primero Auxilio en Evento",
    "Servicio de Publicidad Móvil",
    "Servicio de Reciclaje",
    "Servicio de Reforestación",
    "Servicio de Remolque",
    "Servicio de Reparación",
    "Servicio de Reporte Regulatorio",
    "Servicio de Restauración Ambiental",
    "Servicio de Robótica",
    "Servicio de Seguridad",
    "Servicio de Seguridad Privada",
    "Servicio de Sepelio",
    "Servicio de Subtitulación",
    "Servicio de Taxi",
    "Servicio de Techado",
    "Servicio de Telecomunicación",
    "Servicio de Topografía",
    "Servicio de Tutoría",
    "Servicio de Utilidad",
    "Servicio de Videovigilancia",
    "Servicio Dental",
    "Servicio en la Nube",
    "Servicio Forestal",
    "Servicio Funerario",
    "Servicio Inmobiliario",
    "Servicio Legal",
    "Servicio Militar",
    "Servicio Oceanográfico",
    "Servicio Postal",
    "Servicio Quiropráctico",
    "Servicio Social",
    "Simulacro de Emergencia",
    "Sistema de Control de Acceso",
    "Sistema de Gestión de Contenido (CMS)",
    "Sistema de Información Geográfica (SIG)",
    "Sistema de Riego Automatizado",
    "Sistema de Videovigilancia",
    "Socorro en Desastre",
    "Solución de Autenticación de Identidad",
    "Solución de Comercio Electrónico",
    "Solución de Realidad Mixta",
    "Solución para la Neutralidad de Carbono",
    "Soporte IT y Gestión de Servicio",
    "Spa y Bienestar",
    "Suministro de Equipo de Diagnóstico",
    "Suministro de Oficina",
    "Suministro para Mascota",
    "Taller de Carrocería",
    "Taller de Cocina Internacional",
    "Taller de Cocina Saludable",
    "Taller de Soldadura TIG y MIG",
    "Tapicería Automotriz",
    "Tasación de Bien Inmueble",
    "Tasación de Obra de Arte",
    "Tasación de Propiedad",
    "Tatuaje y Piercing",
    "Teatro y Arte Escénica",
    "Terapia con Cristal",
    "Terapia de Campo Magnético",
    "Terapia de Luz",
    "Terapia de Sonido",
    "Terapia Familiar",
    "Terapia Física para Lesión Deportiva",
    "Terapia Neurológica",
    "Terapia Ocupacional",
    "Terapia de Desintoxicación",
    "Terapia Holística",
    "Testing de Usabilidad para Persona con Discapacidad",
    "Teahouse",
    "Tienda de Alimento Gourmet",
    "Tienda de Peces y Acuario",
    "Tienda de Conveniencia",
    "Tienda de Electrónica",
    "Tienda de Mascota",
    "Tienda de Mueble",
    "Tienda de Ropa",
    "Tienda de Bicicletas",
    "Tiro con Arco",
    "Tienda de Productos de Belleza y Cuidado",
    "Topografía Aérea con Dron",
    "Traducción Audiovisual",
    "Traducción Científica",
    "Traducción de Aplicación Móvil",
    "Traducción de Documento",
    "Traducción de Libro y Manuscrito",
    "Traducción de Material Académico",
    "Traducción Jurídica",
    "Traducción Técnica",
    "Transformación Digital",
    "Transporte Adaptado",
    "Transporte Aéreo de Carga",
    "Transporte de Carga",
    "Transporte Ejecutivo",
    "Transporte Escolar",
    "Transporte Ferroviario",
    "Transporte Marítimo",
    "Transporte Multimodal",
    "Transporte para Persona con Movilidad Reducida",
    "Transporte Público",
    "Traslado de Resto",
    "Tratamiento de Adicción",
    "Tratamiento de Agua",
    "Tratamiento de Madera Contra Plaga",
    "Tratamiento Capilar",
    "Tratamiento con Láser",
    "Tratamiento Corporal",
    "Tratamiento Cosmético Dental",
    "Tratamiento de Belleza No Invasivo",
    "Tratamiento Facial",
    "Tratamiento Inyectable",
    "Tratamiento Oncológico Veterinario",
    "Tratamiento para Ceja y Pestaña",
    "Trámite Funerario",
    "Turismo Local",
    "Uña Acrílica y de Gel",
    "Universidad y Colegio",
    "Urgencia Veterinaria Especializada",
    "Valoración de Joyería",
    "Valoración de Vehículo Clásico",
    "Venta de Lápida y Urna",
    "Venta de Vehículos Motorizados",
    "Venta y Servicio de Neumático",
    "Venta de equipos y utenzilios de cocina comercial",
    "Verificación de Documento Legal",
    "Veterinaria",
    "Videojuego en Línea",
    "Vino y Licor",
    "Visualización de Dato para Negocio",
    "Yoga y Pilates",

    // AI & Emerging Tech
    "Servicio de Inteligencia Artificial Generativa",
    "Consultoría en Prompt Engineering",
    "Desarrollo de Agente de IA",
    "Automatización con IA",

    // Accommodation
    "Glamping",
    "Apart-Hotel",
    "Casa de Huésped",
    "Pensión",
    "Albergue Juvenil",
    "Alojamiento Eco-Turístico",
    "Hospedaje Boutique",
    "Co-Living Space",

    // Remote Work
    "Espacio de Coworking",
    "Oficina Virtual",
    "Servicio para Nómada Digital",
    "Retiro de Trabajo Remoto",

    // Sustainability
    "Consultoría en Economía Circular",
    "Servicio de Huella Hídrica",
    "Auditoría de Sostenibilidad",
    "Certificación B Corp",

    "Consultoría en Plan de Pensión",
    "Guardia de Seguridad",
    "Ingeniería Aeroespacial",
    "Consultoría en Diseño de Vivienda Accesible",
    "Consultoría en Diseño Accesible",
    "Servicio de Plomería",
    "Otro",

    // Health & Wellness
    "Coaching de Sueño",
    "Oficina de Doctor",
    "Medicina Funcional",
    "Longevidad y Anti-Envejecimiento",
    "Breathwork y Técnica de Respiración",

    // Creator Economy
    "Gestión de Creador de Contenido",
    "Producción de Podcast",
    "Consultoría para Influencer",
    "Monetización de Contenido",

    // Electric Mobility
    "Punto de Carga para Vehículo Eléctrico",
    "Conversión de Vehículo a Eléctrico",
    "Bicicleta Eléctrica (E-Bike)",

    // Pet Services Premium
    "Hotel para Mascota de Lujo",
    "Psicología Animal",
    "Entrenamiento Virtual de Mascota",
    "Spa para Mascota",

    // Food Trends
    "Comida Plant-Based",
    "Restaurante Ghost Kitchen",
    "Café de Especialidad",
    "Fermentación Artesanal",
    "Mixología Molecular",

    // MEDICAL DOCTORS & SPECIALIZATIONS
    "Medicina General",
    "Medicina Familiar",
    "Medicina Interna",
    "Cardiología",
    "Dermatología",
    "Pediatría",
    "Ginecología y Obstetricia",
    "Oftalmología",
    "Optometría",
    "Otorrinolaringología",
    "Neurología",
    "Psiquiatría",
    "Oncología",
    "Ortopedia y Traumatología",
    "Urología",
    "Gastroenterología",
    "Endocrinología",
    "Reumatología",
    "Neumología",
    "Nefrología",
    "Hematología",
    "Alergología e Inmunología",
    "Cirugía General",
    "Cirugía Plástica y Reconstructiva",
    "Cirugía Cardiovascular",
    "Anestesiología",
    "Radiología e Imagenología",
    "Patología",
    "Medicina Deportiva",
    "Geriatría",
    "Medicina de Urgencia",
    "Medicina Ocupacional",
    "Proctología",
    "Podología",
    "Flebología",
    "Medicina Estética",
    "Andrología",
    "Periodoncia",
    "Endodoncia",
    "Ortodoncia",
    "Cirugía Oral y Maxilofacial",
    "Odontopediatría",
    "Implantología Dental",
    "Prostodoncia",

    //Smokeshop
    "Smokeshop & Dispensario",

    //Cigars & tabaco
    "Tienda de Tabaco y Cigarros",

    // EXTREME SPORTS & POPULAR ACTIVITIES
    "Deporte Extremo",
    "Paracaidismo",
    "Buceo y Submarinismo",
    "Surf",
    "Kitesurfing",
    "Windsurf",
    "Esquí",
    "Snowboarding",
    "Rafting",
    "Kayak",
    "Parapente",
    "Ala Delta",
    "Ciclismo de Montaña",
    "Escalada en Roca",
    "Bungee Jumping",
    "Tirolesa/Canopy",
    "Paintball",
    "Airsoft",
    "Karting",
    "Motocross",
    "BMX",
    "Skateboarding",
    "Skate shop",
    "Parkour",
    "Wakeboard",
    "Stand Up Paddle (SUP)",
    "Sandboarding",
    "Espeleología",
    "Barranquismo",
    "Rappel",

    // EVERYDAY RETAIL & SERVICES
    "Supermercado",
    "Minimarket",
    "Gasolinera",
    "Estación de Servicio",
    "Banco",
    "Cajero Automático",
    "Lavandería",
    "Tintorería",
    "Ferretería",
    "Zapatería",
    "Óptica",
    "Perfumería",
    "Juguetería",
    "Papelería",
    "Mercado y Plaza",
    "Centro Comercial",
    "Kiosco",
    "Estacionamiento",
    "Farmacia de Turno",
    "Droguería",
    "Salón de Belleza",
    "Peluquería",
    "Barbería",

    // FINANCIAL SERVICES
    "Agencia de Seguro",
    "Seguro de Vida",
    "Seguro de Auto",
    "Seguro de Salud",
    "Seguro de Propiedad",
    "Casa de Empeño",
    "Casa de Cambio",
    "Cooperativa de Crédito",
    "Préstamo Personal",
    "Microfinanza",
    "Asesoría en Seguro",
    "Corretaje de Seguro",
    "Reclamo de Seguro",

    // HEALTHCARE FACILITIES & SERVICES
    "Laboratorio Clínico",
    "Centro de Diagnóstico por Imagen",
    "Clínica de Fertilidad",
    "Banco de Sangre",
    "Clínica de Vacunación",
    "Centro de Rehabilitación",
    "Clínica de Diálisis",
    "Centro de Salud Comunitario",
    "Farmacia de Manipulación",
    "Óptica y Lente de Contacto",
    "Aparato Auditivo",
    "Ortopedia y Prótesis",
    "Servicio de Ambulancia",

    // ENTERTAINMENT & RECREATION
    "Salón de Billar",
    "Salón de Juego (Arcade)",
    "Pista de Patinaje sobre Hielo",
    "Mini Golf",
    "Pista de Go-Kart",
    "Parque de Trampolín",
    "Parque Acuático",
    "Zoológico",
    "Acuario",
    "Planetario",
    "Sala de Escape",
    "Realidad Virtual (Arcade VR)",
    "Boliche",
    "Sala de Bingo",

    // PROFESSIONAL SERVICES
    "Bufete de Abogado",
    "Despacho Contable",
    "Notaría Pública",
    "Agencia Inmobiliaria",
    "Tasador Profesional",
    "Perito Judicial",
    "Mediación y Arbitraje",
    "Servicio de Traducción e Interpretación",
    "Agencia de Empleo Temporal",

    // AUTOMOTIVE
    "Concesionario de Auto",
    "Taller Mecánico",
    "Taller de Transmisión",
    "Alineación y Balanceo",
    "Servicio de Aire Acondicionado Automotriz",
    "Instalación de Audio para Auto",
    "Polarizado de Vidrio",
    "Detallado de Auto",
    "Venta de Auto Usado",
    "Desarmaduria de Auto",
    "Grúa y Remolque",

    // HOME SERVICES
    "Cerrajería",
    "Exterminador",
    "Limpieza de Alfombra",
    "Limpieza de Ventana",
    "Reparación de Electrodoméstico",
    "Instalación de Persiana",
    "Reparación de Techo",
    "Impermeabilización",
    "Instalación de Cerramiento",
    "Servicio de Fumigación",

    // FOOD & BEVERAGE
    "Heladería",
    "Pizzería",
    "Taquería",
    "Sushi Bar",
    "Buffet",
    "Comedor",
    "Fonda",
    "Repostería",
    "Chocolatería",
    "Juguería",
    "Frutería",
    "Pescadería",
    "Carnicería",
    "Panadería Artesanal",
    "Rosticería",
    "Charcutería",

    // EDUCATION
    "Guardería Infantil",
    "Preescolar",
    "Escuela Primaria",
    "Escuela Secundaria",
    "Preparatoria",
    "Academia de Computación",
    "Clase de Inglés",
    "Tutoría Académica",
    "Curso de Certificación Profesional",

    // PERSONAL CARE
    "Centro de Estética Integral",
    "Salón de Uña",
    "Depilación Láser",
    "Centro de Bronceado",
    "Spa de Día",
    "Baño Turco",
    "Sauna",

    //EXTRA
    "Auto Parts",
    "Venta de Accesorios Religiosos",
    "Agrocentro",
    "Venta de Gas",
];

export default businessCategories;